import { render } from "./TraineeListModal.vue?vue&type=template&id=ad950244&scoped=true"
import script from "./TraineeListModal.vue?vue&type=script&lang=js"
export * from "./TraineeListModal.vue?vue&type=script&lang=js"

import "./TraineeListModal.vue?vue&type=style&index=0&id=ad950244&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad950244"]])

export default __exports__